<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "HOC"
    }
</script>

<style scoped>

</style>